import * as lib from "./lib.js";
import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);
var languageData = {};

var i18n = new VueI18n({
	locale: lib.getCookie("language") || navigator.language.split("-")[0],
	messages: languageData,
	silentTranslationWarn: true,
});
window.i18n = i18n;
if (!lib.getCookie("language") && stage.languageId) {
	//如果有配置优先语言
	lib.setCookie("language", stage.languageId);
} else {
	if ($.isNumeric(lib.getCookie("language"))) lib.setCookie("language", ""); //处理旧的方式
	stage.languageId = lib.getCookie("language") || navigator.language.split("-")[0];
}

// 优先使用url中的语言
if (lib.getUrlParam("language")) {
	stage.languageId = i18n.locale = lib.getUrlParam("language");
	lib.setCookie("language", stage.languageId);
}

export function setLanguage(id) {
	//设定语言
	if (!id) {
		if (!stage.languageList) {
			//根据配置生成支持的语言列表
			stage.languageList = "en";//,zh,pt,es,nl,pl,fr,vi,ko
		}
		if (stage.languageList.indexOf(stage.languageId) < 0) stage.languageId = stage.languageList.split(",")[0]; //对于不支持的语言使用第一语言
	}
	let targetId = id || stage.languageId;
	stage.languageId = targetId;
	lib.setCookie("language", targetId);
	if (id) location.reload();
	else {
		i18n.locale = stage.languageId;
		loadLanguage();
	}
	// if(languageData[stage.languageId]==undefined){
	// 	loadLanguage();
	// }
	if ($.type(stage.languageList) == "string") {
		//string类型是初始配置值，需要根据此值进行二次配置
		let codeList = stage.languageList.split(",");
		stage.languageList = [];
		codeList.map((code) => {
			let newLan = [];
			switch (code) {
				case "zh":
					newLan = [getLanguageStr("lang1", "简体中文"), code];
					break;
				case "en":
					newLan = [getLanguageStr("lang2", "English"), code];
					break;
				case "pt":
					newLan = [getLanguageStr("lang3", "葡萄牙语"), code];
					break;
				case "pl":
					newLan = [getLanguageStr("lang4", "波兰语"), code];
					break;
				case "es":
					newLan = [getLanguageStr("lang5", "西班牙语"), code];
					break;
				case "nl":
					newLan = [getLanguageStr("lang6", "荷兰语"), code];
					break;
				case "fr":
					newLan = [getLanguageStr("lang7", "法语"), code];
					break;
				case "vi":
					newLan = [getLanguageStr("me22", "越南语"), code];
					break;
				case "ko":
					newLan = [getLanguageStr("me21", "韩语"), code];
					break;

				// case "":newLan=[getLanguageStr('lang',''),];break;
			}
			stage.languageList.push({ text: newLan[0], value: newLan[1] });
		});
	}
}
export function getLanguageType(id = stage.languageId) {
	var str = "";
	switch (Number(id)) {
		case 1:
			str = "zh";
			break;
		case 2:
			str = "en";
			break;
		case 3:
			str = "pt";
			break;
		case 4:
			str = "pl";
			break;
		case 5:
			str = "es";
			break;
		case 6:
			str = "nl";
			break;
		case 7:
			str = "fr";
			break;
		case 8:
			str = "vi";
			break;
		case 9:
			str = "ko";
			break;
		default:
			str = "en";
			break;
	}
	return str;
}
export function displayLanguage(id) {
	//通过语言id输出最终语言
	let out = "";
	switch (id) {
		case "zh":
			out = getLanguageStr("lang1", "中文");
			break;
		case "en":
			out = getLanguageStr("lang2", "English");
			break;
		case "pt":
			out = getLanguageStr("lang3", "Português");
			break;
		case "pl":
			out = getLanguageStr("lang4", "Polski");
			break;
		case "es":
			out = getLanguageStr("lang5", "Español");
			break;
		case "nl":
			out = getLanguageStr("lang6", "De Nederlandse");
			break;
		case "fr":
			out = getLanguageStr("lang7", "Français");
			break;
		case "vi":
			out = getLanguageStr("me22", "Vietnamese");
			break;
		case "ko":
			out = getLanguageStr("me21", "한국어");
			break;
	}
	return out;
}

export function getLanguageStr(fullStr, reference) {
	//翻译内容并带拼接功能
	var out = "",
		error = false;
	$((fullStr || "").split("+")).each(function (index, text) {
		var tran = i18n.t(text); //oemText()
		out += stage.languageId != "zh" && index > 0 ? " " + tran : tran; //非中文情况下下一个单词需要加空格
		if ((tran == text || !tran) && text.match(/[a-z0-9]/)) error = true; //特殊字符不检测
		// else error=false;
	});
	// $(fullStr.split("")).each(function(){//跳过带特殊字符的拼接
	// 	if(!this.match(/[a-z0-9]/)){
	// 		error=false;
	// 		return;
	// 	}
	// });
	if (error) {
		let toUse = lib.objTool(languageData[stage.languageId], "findByValue", reference);
		// console.log(fullStr+"-"+reference,"可以转用："+toUse);//输出未找到的词条
	}
	// return out=="%"? out:decodeURIComponent(out);
	return out;
}
window.getLanguageStr = getLanguageStr;

function loadLanguage() {
	//加载语言文件
	var languageFile = `${stage.loc.baseRouter}static/i18n/${stage.languageId}.js?v=${stage.ver}`;
	$.ajax(languageFile, {
		type: "GET",
		async: false,
		dataType: "text",
		cache: true,
		success: function (data) {
			//定制词条
			switch (stage.loc.customer) {
				case "Bliq":
					if (stage.languageId == "en") {
						data = data.replace(/gateways\/loggers|gateway\/logger|Gateway\/Logger|gateway\/loggers|Gateways|Logger|logger/g, "Bliq-vanger");
						data = data.replace(/SN/g, "Serial Number");
					} else if (stage.languageId == "nl") {
						data = data.replace(/Logger|logger/g, "Bliq-vanger");
						data = data.replace(/SN/g, "Serienummer");
					}
					break;
			}
			data = $.parseJSON(data);
			if (stage.languageEmptyToken) {
				//给空词条填充
				$.each(data, (key, value) => {
					if (value == "") data[key] = stage.languageEmptyToken;
				});
			}
			languageData[stage.languageId] = data;
		},
	});
}

setLanguage();

export default i18n;



// WEBPACK FOOTER //
// ./src/util/language.js